import React, { useContext } from 'react';
import { AppContext } from '@prisjakt/ui-app-context';
import Clickable from '@prisjakt/ui-clickable';
import TextLink from '@prisjakt/ui-text-link';
import { TitleMediumText, H2Text } from '@prisjakt/ui/text/variants';

import * as S from './styles';

import { ExpertLandingPage } from '../../../../types';

type Props = {
  data: ExpertLandingPage;
};

function ExpertSection({ data }: Props) {
  const { t, linkTo, market } = useContext(AppContext);

  if (!data?.items) return null;

  const { tests, toplists } = data.items;
  const { experts, expertCount } = data;

  const articleUrl = market.articles?.aboutExperts?.path;

  const content = [...tests, ...toplists];

  return (
    <S.ExpertSection>
      <S.Section>
        <S.Main>
          <div>
            <TitleMediumText>{t('expert', 'promo.advice')}</TitleMediumText>
            <H2Text>{t('expert', 'expert.brand-name')}</H2Text>
          </div>

          <S.Description>
            <div>{t('expert', 'entry.promo-text')} </div>

            <div>
              <TextLink to={articleUrl}>
                {t('expert', 'entry.link-to-article-text')}
              </TextLink>
            </div>
          </S.Description>

          <S.Button
            color="primary"
            component={<Clickable to={linkTo('experts')} />}
            $display="desktop"
          >
            {t('expert', 'entry.latest-link')}
          </S.Button>
        </S.Main>

        <S.ExpertList>
          <S.ListOfExperts
            experts={experts}
            count={expertCount || 0}
            limit={9}
            linkRest
          />
        </S.ExpertList>

        <S.Button
          color="primary"
          component={<Clickable to={linkTo('experts')} />}
          $display="mobile"
        >
          {t('expert', 'entry.latest-link')}
        </S.Button>
      </S.Section>

      <S.List>
        <TitleMediumText>{t('expert', 'entry.latest-title')}</TitleMediumText>
        <S.ContentList>
          <S.ContentCards items={content} limit={4} />
        </S.ContentList>
      </S.List>
    </S.ExpertSection>
  );
}

export default ExpertSection;
